<div [formGroup]="group" [attr.class]="styleForm">
    <label *ngIf="label" [attr.for]="controlName">{{ label }}</label>
    <div [class.has-icon]="icon" class="field">
        <i *ngIf="icon" [attr.class]="icon"></i>
        <calendar #field
                           [past]="past"
                           [onlyOneMonth]="true"
                           [tabindex]="index"
                           class="field date-field"
                           [attr.placeholder]="placeholder"
                           [formControlName]="controlName"
                           [dateFormat]="wording[languageService.simpleUserLanguage].dateFormat"
                           [locale]="wording[languageService.simpleUserLanguage]"
                           [minDate]="minDate"
                           [maxDate]="maxDate"
                           [defaultDate]="defaultDate"
                           [selectOtherMonths]="true"
                           [monthNavigator]="monthNavigator"
                           [yearNavigator]="yearNavigator"
                           [yearRange]="yearRange"
                           pages="2"
                           [ngClass]="{ 'hasError': error.condition }"
                           [placeholder]="placeholder"
                           [appendTo]="appendTo"
                           (onFocus)="focusEmit.emit($event)"
                           (onSelect)="onSelectDate($event)"
                           (onBlur)="convertDate($event);onBlur($event)"
        ></calendar>

    </div>
</div>
